import { render, staticRenderFns } from "./Affirm.vue?vue&type=template&id=0af53932&scoped=true"
import script from "./Affirm.vue?vue&type=script&lang=js"
export * from "./Affirm.vue?vue&type=script&lang=js"
import style0 from "./Affirm.vue?vue&type=style&index=0&id=0af53932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af53932",
  null
  
)

export default component.exports